const ONE_HOUR_MS = 60 * 60 * 1000

let timestamps: number[] = []

export const recordXmppReconnect = (at: number = Date.now()): void => {
  timestamps.push(at)
}

export const getReconnectsLastHour = (now: number = Date.now()): number => {
  const cutoff = now - ONE_HOUR_MS
  // Prune in place: keep only entries strictly newer than cutoff.
  timestamps = timestamps.filter((t) => t > cutoff)
  return timestamps.length
}

export const __resetXmppReconnectTrackerForTests = (): void => {
  timestamps = []
}
